module.exports = __webpack_public_path__ + "static/media/icon-activity.ec2ea5c1.svg";